module.exports = __webpack_public_path__ + "static/media/Icono firma digital.96f1d054.svg";